import PropTypes from 'prop-types';
import { useReducer, useEffect, useState, useRef } from 'react';

import { BasicButton, IconButton } from 'components/common/buttons';
import { Icon } from 'components/common';
import { Grid } from '@material-ui/core';

const Captcha = ({ codeCaptcha, onRefresh, state, onChange }) => {
  const canvasRef = useRef(null);

  const drawCaptchaOnCanvas = (ctx, captcha) => {
    ctx.font = '45px Lato';
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    const textColors = ['#3c3c5d', '#3c3c5d'];

    const letterSpace = 150 / captcha.length;
    for (let i = 0; i < captcha.length; i++) {
      const xInitialSpace = 25;
      ctx.fillStyle = textColors[Math.floor(Math.random() * 2)];
      ctx.fillText(
        captcha[i],
        xInitialSpace + i * letterSpace,

        // Randomize Y position slightly
        Math.floor(Math.random() * 16 + 40),
        100
      );
    }
  };

  const initializeCaptcha = ctx => {
    drawCaptchaOnCanvas(ctx, codeCaptcha);
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    initializeCaptcha(ctx);
  }, [codeCaptcha]);

  return (
    <div className="captcha-credential">
      <div className="container-credential">
        <div className="wrapper-credential">
          <Grid container spacing={1} alignItems="center" className="form-spacing">
            <Grid item xs={9} sm={5}>
              <canvas ref={canvasRef} width="200" height="70" />
            </Grid>
            <Grid item xs={3} sm={7} className="flex justify-end">
              <IconButton onClick={onRefresh}>
                <Icon isAssetIcon type="refresh" />
              </IconButton>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

Captcha.defaultProps = {
  state: {},
};

Captcha.propTypes = {
  codeCaptcha: PropTypes.string.isRequired,
  onRefresh: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  state: PropTypes.object,
};

export default Captcha;
